import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { DisableMoreVert, SortDownArrow } from "../../../assets/svg";
import { Badge } from "../../../components/micro/input";
import Action from "../../../components/common/Action";
import DebounceSearch from "../../../components/common/DebounceSearch";
import CustomTable from "../../../components/customTable/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../../components/RippleLoader/RippleLoader";
import { getTechnicianList } from "../../../redux/service/slice";
import { companiesList } from "../../../redux/companies/slice";
import ServicingModal from "./ServicingModal";

const tabs = [
  { label: "All", value: "all" },
  { label: "Unscheduled", value: "unscheduled" },
  { label: "Scheduled", value: "scheduled" },
  { label: "Completed", value: "completed" },
];

const OneTimeRecurring = ({
  setSearchValue,
  searchValue,
  setPageLimit,
  pageLimit,
  setPageCount,
  pageCount,
  setActiveTab,
  activeTab,
  setSortBy,
  sortBy,
  setSortDirection,
  sortDirection,
  technician,
  setTechnician,
  company,
  setComapny,
  getSchedulingListData,
  loading,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [appointmentStatus, setAppointmentStatus] = useState("");
  const [data, setData] = useState("");
  const dispatch = useDispatch();

  // Selector
  const { techniciansList, companiesListData } = useSelector((store) => ({
    techniciansList: store?.technicianData?.getTechnicianListStatus?.data,
    companiesListData: store?.companiesData?.companiesListStatus?.data?.data,
  }));

  useEffect(() => {
    dispatch(
      getTechnicianList({
        pageLimit: "all",
      })
    );
    dispatch(
      companiesList({
        search: "",
        pageLimit: "all",
        status: "",
        sort_by: "name",
        sort_direction: "desc",
        contract: "all",
      })
    );
  }, []);

  const techniciansOptions = Array.isArray(
    techniciansList?.data || techniciansList
  )
    ? (techniciansList?.data || techniciansList).map((technician) => ({
        value: technician.id,
        label: technician.full_name,
      }))
    : [];

  const companyOptions = Array.isArray(
    companiesListData?.data || companiesListData
  )
    ? (companiesListData?.data || companiesListData).map((company) => ({
        value: company.id,
        label: company.name,
      }))
    : [];

  const handleTechnicianChange = (selectedOption) => {
    setTechnician(selectedOption);
  };

  const handleCompanyChange = (selectedOption) => {
    setComapny(selectedOption);
  };

  const handleActionClick = (status, id) => {
    setAppointmentStatus(status);
    setIsModalOpen(true);
    setData(id);
  };

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("id");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>No.</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "id" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("company");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Company</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "company"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("outlet");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Outlet</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "outlet" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("address");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Address</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "address"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("date");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Date & Time</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "date" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("technician");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Technician</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "technician"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("status");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Status </span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "status" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Types
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {getSchedulingListData?.data?.map((element, index) => (
        <tr
          key={index}
          className="font-Proxima text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-5 py-3">{element?.unique_id ?? "-"}</td>
          <td className="px-5 py-3 ">
            {element?.company
              ? element?.company
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3 ">
            {element?.outlet
              ? element?.outlet
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3 ">
            {element?.address
              ? element?.address
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3">
            {element?.date}
            <br />
            {element?.time_range ?? "-"}
          </td>
          <td className="px-5 py-3">
            {element?.technicians
              ? element?.technicians
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3">
            <div className="flex justify-start">
              <Badge
                className={`capitalize ${
                  element?.appointment_status === "scheduled"
                    ? "border-borderGreen text-bgGreen "
                    : element?.appointment_status === "completed"
                    ? "bg-bgGreen text-white"
                    : element?.appointment_status === "unscheduled"
                    ? "border-borderGrey text-black"
                    : ""
                }`}
                value={
                  element?.appointment_status === "scheduled"
                    ? "Scheduled"
                    : element?.appointment_status === "completed"
                    ? "Completed"
                    : element?.appointment_status === "unscheduled"
                    ? "Unscheduled"
                    : "-"
                }
              />
            </div>
          </td>
          <td className="px-5 py-3">
            {element?.type === "" ? "-" : element?.type ?? "-"}
          </td>
          <td className="flex px-5 py-3">
            {element?.appointment_status === "completed" ? (
              <div className="px-3 py-2">
                <DisableMoreVert />
              </div>
            ) : (
              <Action
                optionList={
                  <>
                    {element?.appointment_status === "unscheduled" && (
                      <>
                        <li
                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                          onClick={() =>
                            handleActionClick("unscheduled", {
                              state: { schedule: element },
                            })
                          }
                        >
                          Schedule
                        </li>
                      </>
                    )}
                    {element?.appointment_status === "scheduled" && (
                      <>
                        <li
                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                          onClick={() =>
                            handleActionClick("scheduled", {
                              state: { schedule: element },
                            })
                          }
                        >
                          Reschedule
                        </li>
                      </>
                    )}
                  </>
                }
              />
            )}
          </td>
        </tr>
      ))}
    </>
  );
  return (
    <>
      <div>
        <div>
          <div className="flex justify-end mt-8">
            {tabs.map((tab) => (
              <button
                key={tab.label}
                className={`py-2 w-full font-normal mb-5 h-full px-4 uppercase text-[14px] border-b-2 transition duration-300 font-Proxima ${
                  activeTab === tab.value
                    ? "border-themeBtn text-themeBtn"
                    : "border-transparent text-textSecondary hover:text-themeBtn hover:border-theme text-gray-dark"
                }`}
                onClick={() => setActiveTab(tab.value)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="technician"
            placeholder="Technician"
            options={techniciansOptions}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={technician}
            onChange={handleTechnicianChange}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: technician ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="company"
            placeholder="Company"
            options={companyOptions}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={company}
            onChange={handleCompanyChange}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: company ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "& :active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>
        {!getSchedulingListData || loading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 ">
            <CustomTable
              overflowVisibleLg={true}
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={getSchedulingListData}
              loading={loading}
              showPagination={true}
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              current={pageCount}
              total={getSchedulingListData?.total}
              paginationData={(crPage) => setPageCount(crPage)}
              lastPage={Math.ceil(getSchedulingListData?.total / pageLimit)}
            />
          </div>
        )}
      </div>
      {isModalOpen && (
        <ServicingModal
          onClose={() => setIsModalOpen(false)}
          data={data?.state?.schedule}
          appointmentStatus={appointmentStatus}
        />
      )}
    </>
  );
};

export default OneTimeRecurring;
